import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TranscriberRushNotes from "../CommonDashboard/Transcriber/TranscriberRushNotes";
import TranscriberPipeline from "../CommonDashboard/Transcriber/TranscriberStatusPipeline";
import RORCaseActionSummary from "../CommonDashboard/ROR/RORCaseActionSummary";
import RORInvoiceOverview from "../CommonDashboard/ROR/RORInvoiceOverview";
import TranscriberDoctorWise from "../CommonDashboard/Transcriber/TranscriberDoctorWise";
import TranscriberToDo from "../CommonDashboard/Transcriber/TranscriberToDo";

interface TranscriberSummaryTypeProps {
  onTabChange: () => void;
  userRole: string;
}

const TranscriberSummaryType: React.FC<TranscriberSummaryTypeProps> = ({
  onTabChange,
  userRole,
}) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showRushNotesSummary, setShowRushNotesSummary] = useState(false);

  return (
    <Container fluid className="px-4 dashboard">
      <Row>
        <Col md={3} className="latestcase d-flex align-items-stretch">
          <TranscriberRushNotes
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
        <Col md={6} className=" caseactions d-flex align-items-stretch">
          <RORCaseActionSummary
            onTabChange={onTabChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
        <Col md={3} className="latestcase d-flex align-items-stretch">
          <TranscriberToDo
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary">
        <Col md={12}>
          <TranscriberPipeline
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={12}>
          <RORInvoiceOverview
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={12}>
          <TranscriberDoctorWise
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default TranscriberSummaryType;
